import { useMutation } from "@tanstack/react-query";

import { FileAPI } from "apis/files";

export function useRemoveFile() {
    return useMutation((fileId: number) => FileAPI.removeFile(fileId));
}
